import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Reports} from '../../../helpers/Urls';

const INITIAL_STATE = {isFetching: false};

const SEND_VENDOR_FINANCE_REPORT = 'SEND_VENDOR_FINANCE_REPORT';
const SEND_VENDOR_FINANCE_REPORT_COMPLETED =
  'SEND_VENDOR_FINANCE_REPORT_COMPLETED';
const SEND_VENDOR_FINANCE_REPORT_FAILED = 'SEND_VENDOR_FINANCE_REPORT_FAILED';

export const sendVendorFinanceReport = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SEND_VENDOR_FINANCE_REPORT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Reports.sendVendorFinanceReportURL(),
        data: {...requestData},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({type: SEND_VENDOR_FINANCE_REPORT_COMPLETED, payload: data});
      } else {
        const {message = 'Error'} = response || {};
        dispatch({
          type: SEND_VENDOR_FINANCE_REPORT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SEND_VENDOR_FINANCE_REPORT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export default (state = INITIAL_STATE, action) => {
  const {type} = action || {};
  switch (type) {
    case SEND_VENDOR_FINANCE_REPORT:
      return {...state, isFetching: true};
    case SEND_VENDOR_FINANCE_REPORT_COMPLETED:
    case SEND_VENDOR_FINANCE_REPORT_FAILED:
      return {...state, isFetching: false};
    default:
      return state;
  }
};
